module.exports = __webpack_public_path__ + "img/banner.8da258e5.jpg";